/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PaginatedResponse_ActionHistoryResponse_ } from '../models/PaginatedResponse_ActionHistoryResponse_';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class HistoryActionService {
    /**
     * Download Action Histories Excel
     * 변경 이력 엑셀 다운로드
     *
     * 목록 조회와 동일한 필터를 적용하여 엑셀 파일로 반환합니다.
     * @returns any OK
     * @throws ApiError
     */
    public static appsHistoryViewsDownloadActionHistoriesExcel({
        orgId,
        workspaceId,
        accountId,
        actionType,
        startDate,
        endDate,
        q,
    }: {
        orgId?: string,
        workspaceId?: string,
        accountId?: string,
        actionType?: string,
        startDate?: string,
        endDate?: string,
        q?: string,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/history/action/excel/download',
            query: {
                'org_id': orgId,
                'workspace_id': workspaceId,
                'account_id': accountId,
                'action_type': actionType,
                'start_date': startDate,
                'end_date': endDate,
                'q': q,
            },
        });
    }
    /**
     * List Action Types
     * 액션 타입 목록 조회
     *
     * 사용 가능한 모든 액션 타입을 Key-Value 형태로 반환합니다.
     * 예: {"login": "로그인", "create_article": "게시글 생성", ...}
     * @returns any OK
     * @throws ApiError
     */
    public static appsHistoryViewsListActionTypes(): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/history/action/types',
        });
    }
    /**
     * List Action Models
     * 액션 대상 모델 목록 조회
     *
     * 사용 가능한 모든 액션 대상 모델을 Key-Value 형태로 반환합니다.
     * 예: {"article": "게시글", "org": "기관", ...}
     * @returns any OK
     * @throws ApiError
     */
    public static appsHistoryViewsListActionModels(): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/history/action/models',
        });
    }
    /**
     * List Action Histories
     * 감사 로그 목록 조회 및 검색
     *
     * 감사 로그를 페이징하여 조회합니다. 검색 키워드가 제공되면 검색을 수행합니다.
     *
     * Args:
     * account_id: 계정 ID로 필터링 (선택사항)
     * member_id: 멤버 ID로 필터링 (선택사항)
     * org_id: 기관 ID로 필터링 (선택사항)
     * workspace_id: 워크스페이스 ID로 필터링 (선택사항)
     * action_type: 액션 타입으로 필터링 (선택사항)
     * client_type: 클라이언트 타입으로 필터링 (선택사항)
     * action_target_id: 액션 대상 ID로 필터링 (선택사항)
     * action_target_model: 액션 대상 모델로 필터링 (선택사항)
     * start_date: 시작 일자로 필터링 (선택사항)
     * end_date: 종료 일자로 필터링 (선택사항)
     * q: 검색 키워드 (선택사항) - IP, 대상ID, 대상모델, 계정명, 이메일로 검색
     * @returns PaginatedResponse_ActionHistoryResponse_ OK
     * @throws ApiError
     */
    public static appsHistoryViewsListActionHistories({
        accountId,
        memberId,
        orgId,
        workspaceId,
        actionType,
        clientType,
        actionTargetId,
        actionTargetModel,
        startDate,
        endDate,
        q,
        page = 1,
        perPage = 100,
    }: {
        accountId?: string,
        memberId?: string,
        orgId?: string,
        workspaceId?: string,
        actionType?: string,
        clientType?: string,
        actionTargetId?: string,
        actionTargetModel?: string,
        startDate?: string,
        endDate?: string,
        q?: string,
        page?: number,
        perPage?: number,
    }): CancelablePromise<PaginatedResponse_ActionHistoryResponse_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/history/action',
            query: {
                'account_id': accountId,
                'member_id': memberId,
                'org_id': orgId,
                'workspace_id': workspaceId,
                'action_type': actionType,
                'client_type': clientType,
                'action_target_id': actionTargetId,
                'action_target_model': actionTargetModel,
                'start_date': startDate,
                'end_date': endDate,
                'q': q,
                'page': page,
                'per_page': perPage,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
}
